import { KeyDict } from '.'

export interface LastBotAction {
  message: string,
  db_update: string
}

export interface BotAction {
  type: string,
  frequency: number
}

export class Bot {
  name: string = ''
  cast: string = ''
  last_actions: KeyDict<LastBotAction> = {}
  actions: BotAction[] = []

  constructor (data: any) {
    if (typeof data !== 'object') return
    if (typeof data.name === 'string') this.name = data.name
    if (typeof data.cast === 'string') this.cast = data.cast
    if (typeof data.last_actions === 'object') {
      this.last_actions = {}
      for (const [key, action] of Object.entries(data.last_actions)) {
        this.last_actions[key] = action as LastBotAction
      }
    }
    if (typeof data.actions === 'object') {
      this.actions = data.actions as BotAction[]
    }
  }
}
